export default {
  page: { method: 'get', url: '/claim/page' }, // 提现记录分页
  create: { method: 'post', url: '/claim' }, // 提现
  access: { method: 'get', url: '/access' } // 可用数量
}
